import React from 'react'
import ReactDOM from 'react-dom'

import  { observer, inject } from 'mobx-react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import Drawer from 'material-ui/Drawer'
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List'
import Divider from 'material-ui/Divider'
import IconButton from 'material-ui/IconButton'
import Icon from 'material-ui/Icon'
import Hidden from 'material-ui/Hidden'
import T from 'i18n-react'
import Dialog from 'material-ui/Dialog'
import Reboot from 'material-ui/Reboot'

import { withLayout } from '../utils/hoc'
import { withCookies, Cookies } from 'react-cookie'

import Messenger from './messenger'
import {Search, Filter, ClearFilter} from './search'
import Catalog from './catalog'
import NewExampleForm from './newexampleform'
import NewCollectionForm from './newcollectionform'
import WelcomePage from './welcomepage'
import { Link } from 'react-router-dom'
import route from '../stores/fetchconfig.json'
import { CircularProgress } from 'material-ui/Progress'



@inject('store','ui') @observer
class Start extends React.Component {
  render () {
    const { classes,store,ui } = this.props
    let label = ""
    if (store.exampleForm.asSuggestion) label = T.translate("newexampleform.asSuggestion")
    else if (store.exampleForm.asUpdate) label = T.translate("newexampleform.asUpdate")


    let mainComponent = null
    if (store.initialFetchLoaded) {
      if (store.wpSettings.enabled && ui.catalog.openWelcomePage) {
        mainComponent = <WelcomePage />
      }
      else if (!store.wpSettings.enabled || !ui.catalog.openWelcomePage) {
        mainComponent = <div className={classes.appFrame}>
         <MainBar classes={classes} />
         <MainSearch classes={classes} />
         <MainCatalog classes={classes} />
        </div>
      }
    }

    return (
     <div className={classes.root}>
      <Reboot />

      {!store.initialFetchLoaded && <CircularProgress className="center-center" size={50} />}

      {mainComponent}

      <Messenger />
      {(store.settings.hasMenuLinkOne || store.settings.hasMenuLinkTwo)
        && <OpenLinkDialog classes={classes} menuLink={store.settings.currentMenuLink} />}

      <NewExampleForm
       label={label}
       lehrplan={store.lehrplan}
       example={store.exampleForm.currentExample}

       asSuggestion={store.exampleForm.asSuggestion}
       sendSuggestion={store.sendSuggestion}

       asUpdate={store.exampleForm.asUpdate}
       sendUpdate={store.updateExample}
      />

      <NewCollectionForm
       label={label}
       exampleids={store.cart.items.map(item => {return item.id})}
       collection={store.collectionForm.currentCollection}

       asSuggestion={store.collectionForm.asSuggestion}
       sendSuggestion={store.sendSuggestionCollection}

       asUpdate={store.collectionForm.asUpdate}
       sendUpdate={store.updateCollection}
      />

     </div>
    )
  }

  componentWillMount () {
    this.props.store.getAllMetadata()
  }

  componentDidMount () {
    const { cookies } = this.props
    this.props.store.sudo(cookies.get('token'))
  }
}

@inject('store','ui','newexampleformstore') @observer
class MainBar extends React.Component {
 render () {
   const settings = this.props.store.settings, wpSettings = this.props.store.wpSettings
   const { classes, ui, store } = this.props

   let homeButton = null
   if (wpSettings.enabled) {
     homeButton = <ListItem button>
      <ListItemText
       onClick={ui.catalog.handleOpenWelcomePage}
       primary={<Link to={route.endpoint + "/"} className="unstyle-a">{T.translate("meta.home")}</Link>} />
     </ListItem>
   }

   return (
     <AppBar
      className={classNames(classes.appBar, {
       [classes.appBarShift]: ui.search.isSearchOpen,
       [classes[`appBarShift-left`]]: ui.search.isSearchOpen,
      })}
     >
      <Toolbar disableGutters={!ui.search.isSearchOpen}>

         {store.hasUserDefinedFilters && !ui.search.isSearchOpen && <div className={classes.hasUserDefinedFilters} />}
         <Button
           fab
           mini
           color="secondary"
           aria-label="open drawer"
           onClick={ui.search.toggleSearch}
           className={classNames(classes.menuButton, ui.search.isSearchOpen && classes.hide)}
         >
          <Icon>search</Icon>
         </Button>

         <Typography type="title" color="inherit" noWrap className={classes.flex}>
          {wpSettings.title}
         </Typography>

         <Hidden smDown>
          {settings.hasMenuLinkOne &&
           <Button
            color="inherit"
            onClick={this.openMenuLink.bind(this,settings.menuLinkOne)}
           >
            {settings.menuLinkOne.description}
           </Button>
          }
          {settings.hasMenuLinkTwo &&
           <Button
            color="inherit"
            onClick={this.openMenuLink.bind(this,settings.menuLinkTwo)}
           >
            {settings.menuLinkTwo.description}
           </Button>
          }
          <Button
           color="inherit"
           onClick={this.openNewExampleForm}
          >
           {T.translate("meta.suggestion")}
          </Button>

          <IconButton color="inherit" onClick={ui.catalog.toggleMobileMenu}>
           <Icon>more_vert</Icon>
          </IconButton>

          <Drawer anchor="right" open={ui.catalog.openMobileMenu} onClose={ui.catalog.toggleMobileMenu}>
           <div
            role="button"
            onClick={ui.catalog.toggleMobileMenu}
            onKeyDown={ui.catalog.toggleMobileMenu}
            className={classes.mobileMenu}
           >
           <AppBar className={classNames(classes.appBar,classes.mobileMenuAppbar)}>
            <Toolbar>
             <Typography type="title" color="inherit">
              {wpSettings.title}
             </Typography>
            </Toolbar>
           </AppBar>
            <List className={classes.mobileMenuList}>

             <ListItem button>
              <ListItemText primary={<Link to={route.endpoint + "/impressum"} className="unstyle-a">{T.translate("impressum.title")}</Link>} />
             </ListItem>

             <ListItem button>
              <ListItemText primary={<Link to={route.endpoint + "/datenschutz"} className="unstyle-a">{T.translate("datenschutz.title")}</Link>} />
             </ListItem>

             <ListItem button>
              <ListItemText primary={<Link to={route.endpoint + "/aboutsoftware"} className="unstyle-a">{T.translate("aboutsoftware.title")}</Link>} />
             </ListItem>

             {homeButton}

            </List>

           </div>
          </Drawer>

         </Hidden>

         <Hidden mdUp>
          <IconButton color="inherit" onClick={ui.catalog.toggleMobileMenu}>
           <Icon>more_vert</Icon>
          </IconButton>
          <Drawer anchor="right" open={ui.catalog.openMobileMenu} onClose={ui.catalog.toggleMobileMenu}>
           <div
            role="button"
            onClick={ui.catalog.toggleMobileMenu}
            onKeyDown={ui.catalog.toggleMobileMenu}
            className={classes.mobileMenu}
           >
            <AppBar className={classNames(classes.appBar,classes.mobileMenuAppbar)}>
             <Toolbar>
              <Typography type="title" color="inherit">
               {wpSettings.title}
              </Typography>
             </Toolbar>
            </AppBar>
            <List className={classes.mobileMenuList}>
            {settings.hasMenuLinkOne &&
             <ListItem button>
              <ListItemText primary={settings.menuLinkOne.description} onClick={this.openMenuLink.bind(this,settings.menuLinkOne)} />
             </ListItem>
            }
             {settings.hasMenuLinkTwo &&
              <ListItem button>
               <ListItemText primary={settings.menuLinkTwo.description} onClick={this.openMenuLink.bind(this,settings.menuLinkTwo)} />
              </ListItem>
             }
             <ListItem button>
              <ListItemText primary={T.translate("meta.suggestion")} onClick={this.openNewExampleForm} />
             </ListItem>
             <ListItem button>
              <ListItemText primary={<Link to={route.endpoint + "/impressum"} className="unstyle-a">{T.translate("impressum.title")}</Link>} />
             </ListItem>

             <ListItem button>
              <ListItemText primary={<Link to={route.endpoint + "/datenschutz"} className="unstyle-a">{T.translate("datenschutz.title")}</Link>} />
             </ListItem>

             <ListItem button>
              <ListItemText primary={<Link to={route.endpoint + "/aboutsoftware"} className="unstyle-a">{T.translate("aboutsoftware.title")}</Link>} />
             </ListItem>

             {homeButton}

            </List>

           </div>
          </Drawer>
         </Hidden>

       </Toolbar>
     </AppBar>
   )
 }

 openNewExampleForm = () => {
   this.props.store.setExampleFormAsSuggestion()
   this.props.newexampleformstore.clear()
   this.props.ui.newExampleForm.setStep(0)
   this.props.ui.newExampleForm.handleOpen()
 }

 openMenuLink = (menuLink) => {
  this.props.store.settings.setCurrentMenuLink(menuLink)
  this.props.ui.catalog.handleOpenLinkDialog()
 }
}

@inject('ui','store') @observer
class SearchHeader extends React.Component {
  render () {
    const { ui,store,classes } = this.props
    return (
      <div className={classes.drawerInner}>
        <div className={classes.drawerHeader}>
         <AppBar position="absolute">
          <Toolbar>
           <IconButton color="inherit" onClick={this.search}>
            <Icon>search</Icon>
           </IconButton>
           <Search />
           <IconButton color="inherit" className={classes.closeDrawerButton} onClick={ui.search.handleCloseSearch}>
            <Icon>keyboard_arrow_right</Icon>
           </IconButton>
          </Toolbar>
         </AppBar>
        </div>
       <Filter />
      </div>
    )
  }

  search = () => {
    this.props.store.resetCatalog()
  }
}

@inject('ui') @observer
class MainSearch extends React.Component {
  render () {
    const { ui, classes } = this.props
    return (
      <Drawer
       type="persistent"
       anchor="left"
       classes={{
         paper: classes.drawerPaper,
       }}
       open={ui.search.isSearchOpen}
     >
      <div className={classes.searchNavigation}>
       <SearchHeader classes={classes} />
       <ClearFilter />
      </div>
     </Drawer>
    )
  }
}

@inject('ui') @observer
class MainSearchMobile extends React.Component {
  render () {
    const { ui, classes } = this.props
    return (
      <Drawer
       type="temporary"
       anchor="left"
       classes={{
         paper: classes.drawerPaper,
       }}
       ModalProps={{
         keepMounted: true, // Better open performance on mobile.
       }}
       open={ui.search.isSearchOpen}
       onClose={ui.search.handleCloseSearch}
     >
      <div className={classes.searchNavigation}>
       <SearchHeader classes={classes} />
       <ClearFilter />
      </div>
     </Drawer>
    )
  }
}

@inject('ui') @observer
class MainCatalog extends React.Component {
  render () {
    const { ui, classes } = this.props
    return (
      <main ref={main => this.main = main}
       className={classNames(classes.content, classes.smoothScrolling, classes[`content-left`], {
        [classes.contentShift]: ui.search.isSearchOpen,
        [classes[`contentShift-left`]]: ui.search.isSearchOpen,
       })}
      >
       <div className={classNames(classes.catalogDecorator,
        {[classes.decorateCatalogMobile]: (ui.catalog.windowWidth + 50) <= ui.catalog.xs && ui.search.isSearchOpen},
        classes.smoothScrolling
       )}/>
       <Catalog />
     </main>
    )
  }

  componentDidMount () {
    this.props.ui.catalog.setCatalogFrame( ReactDOM.findDOMNode(this.main) )
  }
}

@inject('ui') @observer
class OpenLinkDialog extends React.Component {
  render () {
    const ui = this.props.ui.catalog, classes = this.props.classes, menuLink = this.props.menuLink
    return (
     <Dialog
      fullScreen
      open={ui.openLinkDialog}
      onClose={ui.handleCloseLinkDialog}
     >

      <div className={classes.root}>
        <AppBar className={classes.appBar}>
         <Toolbar>
          <IconButton
           color="inherit"
           onClick={ui.handleCloseLinkDialog}
           aria-label="Close"
          > <Icon>close</Icon> </IconButton>
          <Typography type="title" color="inherit" className={classes.flex}> {menuLink.description} </Typography>
          <IconButton color="inherit" href={menuLink.url}>
           <Icon>exit_to_app</Icon>
          </IconButton>
         </Toolbar>
        </AppBar>
        <div className={classNames(classes.content,classes.iframecontent)}>
         <iframe className={classes.iframe} src={menuLink.url}></iframe>
        </div>
      </div>

     </Dialog>
    )
  }
}


const drawerWidth = 250

const styles = theme => ({
  root: {
    width: '100%',
    height:'100vh',
    zIndex: 1,
    overflow: 'hidden',
  },
  appFrame: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  appBar: {
    position: 'absolute',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  'appBarShift-left': {
    marginLeft: drawerWidth,
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20,
    minWidth:10
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    width: 260,
    position: 'relative',
    height: '100%',
    'overflow-x':'hidden',
      [theme.breakpoints.up('md')]: {
        width: drawerWidth,

      },
},
drawerHeader: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: '0 8px',
  ...theme.mixins.toolbar,
},
  closeDrawerButton: {
    flex:1,
  },
  flex:{
    flex:1,
  },
  content: {
    position:'relative',
    width: '100%',
    overflow:'auto',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: 10,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 'calc(100% - 56px)',
    marginTop: 56,
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 64px)',
      marginTop: 64,
    },
  },
  'content-left': {
    marginLeft: -drawerWidth,
  },
  contentShift: {
   transition: theme.transitions.create('margin', {
     easing: theme.transitions.easing.easeOut,
     duration: theme.transitions.duration.enteringScreen,
   }),
 },
  'contentShift-left': {
   marginLeft: 0,
 },
  hasUserDefinedFilters: {
    backgroundColor: "#fff",
    top: 15,
    left: 35,
    width: 10,
    height: 10,
    display: "flex",
    position: "absolute",
    flexWrap: "wrap",
    alignItems: "center",
    borderRadius: "50%",
    alignContent: "center",
    flexDirection: "row",
    justifyContent: "center",
  },
  searchNavigation:{
    height:"100vh"
  },
  iframe:{
    width:"100%",
    height:"100%",
    border:'none',
  },
  iframecontent:{
    marginLeft:'auto',
    marginRight:'auto',
    padding:0
  },
  mobileMenu:{
    width:250
  },
  mobileMenuList:{
    marginTop: 56,
    [theme.breakpoints.up('sm')]: {
      marginTop: 64
    },
  },
  mobileMenuAppbar:{
    height:56,
    [theme.breakpoints.up('sm')]: {
      height: 64
    }
  },
  catalogDecorator:{
    display:'none',
    background:'#fafafa',
    position:'fixed',
    zIndex:10,
    right:0,
    top:0,
    width:250,
    height:"100%"
  },
  decorateCatalogMobile:{
    display:'block'
  },
  smoothScrolling:{
   'overflow-y':'scroll',
   '-webkit-overflow-scrolling': 'touch'
  }
});

Start.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}


export default withStyles(styles, { withTheme: true })(withLayout(withCookies(Start)))



// WEBPACK FOOTER //
// ./src/components/start.js